<!--flex=> src/com/ubi/clearing/finance/FinanceJobInfoWindow.mxml-->
<template>
  <el-dialog
    v-el-drag-dialog
    custom-class
    :close-on-click-modal="false"
    :visible.sync="innerVisible"
    :title="$t('FinanceManage.finance_businessAdjustment')"
    width="500px"
    @close="cancel"
  >
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="90px" label-position="left" @submit.native.prevent>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('FinanceManage.adjustmentItem')">
            <el-select v-model="adjustmentItem.value" no="adjustmentItem" filterable @change="onAdjustmentItemChange">
              <el-option
                v-for="item in adjustmentItem.list"
                :key="item.code"
                :value="item.code"
                :label="adjustmentItem.labelFunc?adjustmentItem.labelFunc(item):item.chineseName"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('FinanceManage.adjustmentValue')">
            <!-- 文本-->
            <el-input
              v-if="states[currentState].type===componentTypes.textCm"
              v-model="states[currentState].value"
              no="textCm"
            />
            <!-- textarea -->
            <el-input
              v-if="states[currentState].type===componentTypes.textareaCm"
              v-model="states[currentState].value"
              no="textareaCm"
              type="textarea"
              :rows="5"
            />
            <!--日期-->
            <el-date-picker
              v-else-if="states[currentState].type===componentTypes.dateCm"
              :key="'date-'+currentState"
              v-model="states[currentState].value"
              no="dateCm"
              :disabled="disableDate"
              style="width: 210px"
              value-format="yyyy-MM-dd"
              clearable
            />
            <!-- 用户控件-->
            <cargo-advance-select
              v-else-if="states[currentState].type===componentTypes.userCm"
              :key="'user-'+currentState"
              no="userCm"
              :search-data-filter-function="(item)=>{return item.active===true}"
              filterable
              :select-type="selectTypeNames.basic_data_User"
              callback-method-type="obj"
              :default-value="states[currentState].value===0?'':states[currentState].value"
              :static-options="states[currentState].dataList"
              @parentCallBack="onUserChange"
            />

            <!--缓存控件-->
            <cargo-advance-select
              v-else-if="states[currentState].type===componentTypes.cacheCm"
              :key="'cache-'+currentState"
              no="cacheCm"
              filterable
              options-width="300px"
              :select-type="states[currentState].cacheKey"
              :method-params="states[currentState].methodParams"
              :default-value="states[currentState].value==0?'':states[currentState].value"
              @parentCallBack="($event)=>{states[currentState].value = $event.value}"
            />

            <!-- 项目编号 -->
            <cargo-project-select
              v-else-if="states[currentState].type===componentTypes.projectNoCm"
              :key="'poNo-'+currentState"
              no="poNo"
              :default-value="states[currentState].value"
              :customer-id="customerId"
              :is-linked="isProjectLinkedCustomer"
              @change="p=>{changeProject(p)}"
            />

            <!-- 选择指定货 特有的-->
            <template
              v-if="currentState===states.cargoSource.state&&states.cargoSource.value==='NC'"
            >
              <cargo-advance-select
                :key="2"
                no="newValue2"
                style="margin-top: 5px;"
                filterable
                :placeholder="$t('CargoMsg.Cargo_PleaseAddNominationCargoAgent')"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{designationAgent:true}"
                :search-data-filter-function="(item)=>{return item.active===true}"
                :default-value="resultData.newValue2==0?'':resultData.newValue2"
                @parentCallBack="resultData.newValue2 = $event.value"
              />
            </template>

            <template
              v-if="currentState===states.customerRemarks.state"
            >
              <el-select
                v-model="states[currentState].value"
                no="19"
                :clearable="true"
                :allow-create="true"
                filterable
                @blur="selectCustomerRemarksBlur"
              >
                <el-option
                  v-for="(item,index) in states[currentState].dataList"
                  :key="index"
                  :label="item.lable"
                  :value="item.lable"
                />
              </el-select>
            </template>
          </el-form-item>
          <el-form-item v-if="(adjustmentItem.value===34||adjustmentItem.value===35)&&(resultData.lob==='SE'||resultData.lob==='AE'||resultData.lob==='RE')">
            <span style="color: red;">※{{ $t('FinanceManage.BusinessSyncModifyBusinessDate') }}</span>
          </el-form-item>
          <el-form-item v-if="(adjustmentItem.value===25||adjustmentItem.value===26)&&(resultData.lob==='SI'||resultData.lob==='AI'||resultData.lob==='RI')">
            <span style="color: red;">※{{ $t('FinanceManage.ImportBusinessSyncModifyBusinessDate') }}</span>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button no="Confirm" :disabled="disableDate" type="primary" size="mini" @click="confirm">{{ $t('FinanceManage.Confirm') }}</el-button>
      <el-button no="Cancel" size="mini" @click="cancel">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import { cacheName, cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { Assert } from '@/utils/validate'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { Job } from '@/class/model/booking/Job'
import { getFilterCacheList, cacheKeys, getObjectByCache } from '@/utils/basicDataCache'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import {
  BUSINERSSADJUSTMENT_DEPARTURE_STATION,
  BUSINERSSADJUSTMENT_DESTINATION_STATION, BUSINERSSADJUSTMENT_FORWARDING_AGENT
} from '@/class/cargo/model/parameters/SystemConstants'
import { queryCustomerRemarksHistory } from '@/api/SeaImport/seaImportJob'

/**
 * 组件分为如下几类:
 * user：分别获取数据，并进行暂时缓存
 * basic_data_cache ： 通过缓存获取
 * date: 日期
 * text: 文本
 */

const textCm = 'text'
const dateCm = 'date'
const cacheCm = 'cache'
const userCm = 'user'
const textareaCm = 'textarea'
const projectNoCm = 'projectNo'
const listCm = 'list'
const componentTypes = {
  textCm, userCm, dateCm, cacheCm, textareaCm, projectNoCm, listCm
}
export default {
  name: 'BusinessAdjustDialog',
  components: { cargoAdvanceSelect, cargoProjectSelect },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      branchOfficeCheck: false,
      salesOfficeCheck: false,
      selectTypeNames: TYPE_NAMES,
      adjustmentItem: {
        labelFunc: null,
        value: 0,
        list: []
      },
      resultData: { // 确认提交的结果值
        lob: '',
        filedName: '',
        filedCode: '',
        newValue: '',
        newValue1: '',
        newValue2: '',
        quantity: '',
        weight: '',
        cubage: '',
        oldValue: ''
      },
      userDepartmentOfficesCacheMap: new Map(), //
      userDepartmentCacheMap: new Map(), // 用来缓存用户的默认部门
      componentTypes,
      currentState: 'init',
      states: {
        init: { state: 'init', type: componentTypes.textCm, value: '' },
        csr: { state: 'csr', type: componentTypes.userCm, dataList: [], value: 0 },
        op: { state: 'op', type: componentTypes.userCm, dataList: [], value: 0 },
        dc: { state: 'dc', type: componentTypes.userCm, dataList: [], value: 0 },
        sales: { state: 'sales', type: componentTypes.userCm, dataList: [], value: 0 },
        planner: { state: 'planner', type: componentTypes.userCm, dataList: [], value: 0 },
        overseaOp: { state: 'overseaOp', type: componentTypes.userCm, dataList: [], value: 0 },
        bookingterm: { state: 'bookingterm', type: componentTypes.cacheCm, value: '', methodParams: {}, cacheKey: '' }, // 缓存key根据逻辑动态设置
        bookingAgent: { state: 'bookingAgent', type: componentTypes.cacheCm, value: '', methodParams: { bookingAgent: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Company },
        forwardingAgent: { state: 'forwardingAgent', type: componentTypes.cacheCm, value: '', methodParams: { forwardingAgent: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Company },
        cargoSource: { state: 'cargoSource', type: componentTypes.cacheCm, value: '', methodParams: {}, cacheKey: TYPE_NAMES.local_cache_CargoSource },
        date: { state: 'date', type: componentTypes.dateCm, visible: false, value: moment().format('YYYY-MM-DD') },
        designationAgent: { state: 'designationAgent', type: componentTypes.cacheCm, value: '', methodParams: { designationAgent: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Company },
        customer: { state: 'customer', value: '', type: componentTypes.cacheCm, methodParams: { customer: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Company },
        carrier: { state: 'carrier', value: '', type: componentTypes.cacheCm, methodParams: { seaCmp: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Company },
        carrierAgent: { state: 'carrierAgent', value: '', type: componentTypes.cacheCm, methodParams: { seaCmpAgent: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Company },
        jobType: { state: 'jobType', value: '', methodParams: { type: this.job.lob }, type: componentTypes.cacheCm, cacheKey: TYPE_NAMES.basic_data_CutomJobType },
        customsBroker: { state: 'customsBroker', type: componentTypes.cacheCm, value: '', methodParams: { customsBroker: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Company },
        trucking: { state: 'trucking', value: '', type: componentTypes.cacheCm, methodParams: { truckCmp: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Company },
        warehouse: { state: 'warehouse', type: componentTypes.cacheCm, value: '', methodParams: { warehouse: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Company },
        textarea: { state: 'textarea', type: componentTypes.textareaCm, value: '' },
        userDefinedRoleId1: { state: 'userDefinedRoleId1', type: componentTypes.userCm, dataList: [], value: 0 },
        userDefinedRoleId2: { state: 'userDefinedRoleId2', type: componentTypes.userCm, dataList: [], value: 0 },
        salesOfGoods: { state: 'salesOfGoods', type: componentTypes.userCm, dataList: [], value: 0 },
        projectNo: { state: 'projectNo', type: componentTypes.projectNoCm, value: '' },
        loadingPort: { state: 'loadingPort', type: componentTypes.cacheCm, value: '', methodParams: { loadingPort: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Seaport },
        dischargingPort: { state: 'dischargingPort', type: componentTypes.cacheCm, value: '', methodParams: { dischargingPort: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Seaport },
        loadingAirport: { state: 'loadingAirport', type: componentTypes.cacheCm, value: '', methodParams: { loadingAirport: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Airport },
        dischargingAirport: { state: 'dischargingAirport', type: componentTypes.cacheCm, value: '', methodParams: { dischargingAirport: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Airport },
        dischargingAirportImport: { state: 'dischargingAirportImport', type: componentTypes.cacheCm, value: '', methodParams: { dischargingAirportImport: true, active: true }, cacheKey: TYPE_NAMES.basic_data_Airport },
        departureStation: { state: 'departureStation', type: componentTypes.cacheCm, value: '', methodParams: { departureStation: true, active: true }, cacheKey: TYPE_NAMES.basic_data_RailwayStation },
        destinationStation: { state: 'destinationStation', type: componentTypes.cacheCm, value: '', methodParams: { destinationStation: true, active: true }, cacheKey: TYPE_NAMES.basic_data_RailwayStation },
        goodsCategories: { state: 'goodsCategories', type: componentTypes.cacheCm, value: '', methodParams: { goodsCategories: true, active: true }, cacheKey: TYPE_NAMES.basic_data_CargoInformation },
        incoTerm: { state: 'incoTerm', type: componentTypes.cacheCm, value: '', methodParams: { incoTerm: true, active: true }, cacheKey: TYPE_NAMES.basic_data_IncoTerm },
        customerRemarks: { state: 'customerRemarks', type: componentTypes.listCm, dataList: [], value: '' },
        paymentTermMBL: { state: 'paymentTermMBL', type: componentTypes.cacheCm, value: '', methodParams: { paymentTermMBL: true, active: true }, cacheKey: TYPE_NAMES.basic_data_PaymentTerm },
        paymentTermHBL: { state: 'paymentTermHBL', type: componentTypes.cacheCm, value: '', methodParams: { paymentTermHBL: true, active: true }, cacheKey: TYPE_NAMES.basic_data_PaymentTerm }
      },
      openProjectConfig: false, // 项目编号
      isProjectLinkedCustomer: false,
      customerId: 0, // 业务的委托单位,
      isSyncPOD: true
    }
  },
  computed: {
    disableDate() {
      const adjustVal = this.adjustmentItem.value
      return !!this.job.lclMasterUuid && (adjustVal === 25 || adjustVal === 26 || adjustVal === 34 || adjustVal === 35 ||
        adjustVal === 36 || adjustVal === 37 || adjustVal === 38 || adjustVal === 39)
    }
  },
  created() {
    this.resultData.lob = this.job.lob
    let list = [...SystemConstants.BUSINERSSADJUSTMENT_TYPE]
    if (this.resultData['lob'] === 'AE') {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_WEIGHT)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_BOOKINGTERM2)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_AIRPORT_OF_LOADING)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_AIRPORT_OF_DISCHARGE)
    }
    if (this.resultData['lob'] === 'AI' || this.resultData['lob'] === 'SI') {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_DESTINATIONAGENT_POL)
    }
    if (this.resultData['lob'] === 'SE' || this.resultData['lob'] === 'AE') {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_DESTINATIONAGENT_POD)
    }
    if (this.resultData['lob'] === 'SE' || this.resultData['lob'] === 'SI') {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_BOOKINGTERM)
    }
    if (this.resultData['lob'] === 'SE' || this.resultData['lob'] === 'SI' || this.resultData['lob'] === 'IE') {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_PORT_OF_LOADING)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_PORT_OF_DISCHARGE)
    }
    if (this.resultData['lob'] === 'AI') {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_AIRPORT_OF_LOADING)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_AIRPORT_IMPORT_OF_DISCHARGE)
    }
    if (!this.job.masterFlag) {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_CUSTOMER)
    }
    if (this.job.cargoSource === 'NC') {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_DESIGNATIONAGENT)
    }
    if (this.resultData['lob'] === 'SE') {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_CARRIER_AGENT)
    }
    // 空进主票不显示报关
    if (!(this.job.lob.indexOf('AI') > -1 && this.job.masterFlag)) {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_CUSTOMS_BROKER)
    }
    // 空运业务主票不显示仓库
    if (!(this.job.lob.indexOf('A') > -1 && this.job.masterFlag)) {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_WAREHOUSE)
    }
    if (this.job.landTransportation) {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_TRUCKING_COMPANY)
    }
    if (this.resultData['lob'] === 'RE' || this.resultData['lob'] === 'RI' || this.resultData['lob'] === 'AI') {
      // 若业务类型是空运进口或铁路出口，应该去除“约价性质”
      list = list.filter(item => {
        return item.code !== 4
      })
    }
    if (this.resultData['lob'] === 'RE' || this.resultData['lob'] === 'RI' || this.resultData['lob'] === 'AE' || this.resultData['lob'] === 'SE' ||
      this.resultData['lob'] === 'AI' || this.resultData['lob'] === 'SI') {
      if (this.resultData['lob'] === 'RE' || this.resultData['lob'] === 'RI') {
        list.push(SystemConstants.BUSINERSSADJUSTMENT_RAILWAY_ETA)
      } else {
        list.push(SystemConstants.BUSINERSSADJUSTMENT_ETA)
      }
    }
    if (this.resultData.lob === 'SE' || this.resultData.lob === 'SI' || this.resultData.lob === 'AE' || this.resultData.lob === 'AI') {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_ETD)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_ATD)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_ATA)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_GOODS_CATEGORIES)
    } else if (this.resultData.lob === 'RE' || this.resultData.lob === 'RI') {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_RAILWAY_ETD)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_RAILWAY_ATD)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_RAILWAY_ATA)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_DEPARTURE_STATION)
      list.push(SystemConstants.BUSINERSSADJUSTMENT_DESTINATION_STATION)
      // 发运代理
      list.push(SystemConstants.BUSINERSSADJUSTMENT_FORWARDING_AGENT)
    }
    // 综合物流且是整车/零担
    if (this.resultData['lob'] === 'IE' && this.job.containerLoadType === 'CL') {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_GOODS_CATEGORIES)
    }
    // 添加贸易条款
    list.push(SystemConstants.BUSINERSSADJUSTMENT_INCOTERM)
    // 海进-委托单位抬头
    if (this.job.lob === SystemConstants.SI.code) {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_CUSTOMER_REMARKS)
    }
    // 主单运费条款
    if ([SystemConstants.SE.code, SystemConstants.SI.code, SystemConstants.AE.code, SystemConstants.AI.code].includes(this.job.lob)) {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_PAYMENT_TERM_MBL)
    }
    // 分单运费条款
    if ([SystemConstants.SE.code, SystemConstants.SI.code, SystemConstants.AE.code, SystemConstants.AI.code].includes(this.job.lob)) {
      list.push(SystemConstants.BUSINERSSADJUSTMENT_PAYMENT_TERM_HBL)
    }

    this.adjustmentItem.list = list
    this.toDealAdjustmentItemLabel()
    this.adjustmentItem.value = list[0].code
    this.onAdjustmentItemChange(list[0].code)
  },
  async beforeMount() {
    await cache.load(cacheName.CONFIG)
    this.branchOfficeCheck = Number(cache.config.get('departmentSalesOfficeCheck')) === 1
    this.salesOfficeCheck = Number(cache.config.get('SalesOfficeCheck')) === 1
    this.openProjectConfig = Number(cache.config.get('openProjectConfig')) === 1
    this.isProjectLinkedCustomer = Number(cache.config.get('isProjectLinkedCustomer')) === 1 // 项目是否和委托单位关联
    this.isSyncPOD = Number(cache.config.get('SyncPOD')) === 1
  },
  methods: {
    toDealAdjustmentItemLabel() {
      this.adjustmentItem.labelFunc = (item) => {
        if (item.code === 10 && (this.job.lob === 'RE' || this.job.lob === 'RI')) {
          // 航线负责人=》路线负责人
          return this.$t('FinanceManage.routeLeader')
        }
        return this.$store.getters.language === 'zh' ? item.chineseName : item.englishName
      }
    },
    // 调整项发生变化监听
    async onAdjustmentItemChange(code) {
      const commonState = this.adjustmentItem.list.find(item => item.code === code)
      // this.currentState = commonState.code
      this.resultData.filedName = commonState.chineseName

      this.resultData.filedCode = commonState.englishName
      this.resultData.oldValue = ''
      const currentOffice = this.$store.getters.currentOffice

      const obj = this.resultData
      const job = this.job
      if (code === 10 && (job.lob === 'RE' || job.lob === 'RI')) {
        this.resultData.filedName = '路线负责人'
      }
      switch (Number(commonState.code)) {
        case 0:
          this.currentState = 'init'
          break
        case 1:
          this.currentState = 'csr'
          if (this.states.csr.dataList.length > 0) {
            // 判断是否已经获取过值
            break
          }
          if (job) {
            if (job.csrOffice !== 0) {
              this.states.csr.dataList = await User.getUsersByPrivilegeDetail('role', 'csr', null, this.job.csrOffice)
            } else {
              this.states.csr.dataList = await User.getUsersByPrivilegeDetail('role', 'csr', null, this.$store.getters.currentOfficeId)
            }
            this.states.csr.value = job.csr
            obj.newValue1 = job.csrDepartment
            obj.newValue2 = job.csrOffice
          } else {
            this.states.csr.dataList = await User.getUsersByPrivilegeDetail('role', 'csr', null, currentOffice.code === 'HQ' ? null : this.$store.getters.currentOfficeId)
            this.states.csr.value = this.states.csr.value || 0
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 2:
          this.currentState = 'op'
          if (job) {
            if (job.opOffice !== 0) {
              this.states.op.dataList = await User.getUsersByPrivilegeDetail('role', 'op', null, this.job.opOffice)
            } else {
              this.states.op.dataList = await User.getUsersByPrivilegeDetail('role', 'op', null, this.$store.getters.currentOfficeId)
            }
            this.states.op.value = job.op
            obj.newValue1 = job.opDepartment
            obj.newValue2 = job.opOffice
          } else {
            this.states.op.dataList = await User.getUsersByPrivilegeDetail('role', 'op', null, currentOffice.code === 'HQ' ? null : this.$store.getters.currentOfficeId)
            this.states.op.value = this.states.op.value || 0
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 3:
          this.currentState = 'dc'
          // dc.autoKey = "auto_csr"; todo 个性化key
          if (job) {
            if (job.dcOffice !== 0) {
              this.states.dc.dataList = await User.getUsersByPrivilegeDetail('role', 'doc', null, this.job.dcOffice)
            } else {
              this.states.dc.dataList = await User.getUsersByPrivilegeDetail('role', 'doc', null, this.$store.getters.currentOfficeId)
            }

            this.states.dc.value = job.dc
            obj.newValue1 = job.dcDepartment
            obj.newValue2 = job.dcOffice
          } else {
            this.states.dc.dataList = await User.getUsersByPrivilegeDetail('role', 'doc', null, currentOffice.code === 'HQ' ? null : this.$store.getters.currentOfficeId)
            this.states.dc.value = 0
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 4:
          this.currentState = 'bookingterm'
          if (job) {
            if (job.lob === 'SE') {
              this.states.bookingterm.cacheKey = TYPE_NAMES.local_cache_BookingTermSEA
              this.states.bookingterm.value = job.bookingTerm
            }
            if (job.lob === 'SI') {
              this.states.bookingterm.cacheKey = TYPE_NAMES.local_cache_BookingTermSEA
              this.states.bookingterm.value = job.bookingTerm
            }
          }
          break
        case 5:
          this.currentState = 'bookingAgent'
          if (job) {
            this.states.bookingAgent.value = job.bookingAgent
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 6:
          this.currentState = 'carrier'
          if (job) {
            this.states.carrier.value = job.carrierId
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 7:
          this.currentState = 'cargoSource'
          if (job) {
            if (job.cargoSource === null || job.cargoSource === 'NC') {
              this.states.cargoSource.value = 'NC' // 指定货
            } else {
              this.states.cargoSource.value = 'SC' // 自揽货
            }
            // todo
            // this.states.cargoSource.value = job.cargoSource
            obj.newValue2 = job.designationAgent
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 8:
          this.currentState = 'sales'
          // todo  sales.autoKey = 'auto_sales'
          if (job) {
            if (this.salesOfficeCheck) {
              this.states.sales.dataList = await User.getUsersByPrivilegeDetail('role', 'sales', null, this.$store.getters.currentOfficeId)
            } else {
              this.states.sales.dataList = await User.getUsersByPrivilegeDetail('role', 'sales', null, job.salesOffice)
            }
            this.states.sales.value = job.sales
            obj.newValue1 = job.salesDepartment
            obj.newValue2 = job.salesOffice
          } else {
            this.states.sales.dataList = await User.getUsersByPrivilegeDetail('role', 'sales', null, currentOffice.code === 'HB' ? null : this.$store.getters.currentOfficeId)
            this.states.sales.value = 0
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 9:
          this.currentState = 'init'
          if (job) {
            this.states.init.value = job.customerRefNo
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 10:
          this.currentState = 'planner'
          if (job) {
            if (job.opOffice !== 0) {
              if (job.lob === 'SE' || job.lob === 'SI') {
                this.states.planner.dataList = await User.getUsersByPrivilegeDetail('role', 'sealine', null, job.opOffice)
              } else if (job.lob === 'AE' || job.lob === 'AI') {
                this.states.planner.dataList = await User.getUsersByPrivilegeDetail('role', 'airline', null, null)
              } else {
                // 原cargo的bug，补充铁出的设值， 铁出是新加的，入参和海出一致
                this.states.planner.dataList = await User.getUsersByPrivilegeDetail('role', 'railwayLine', null, job.opOffice)
              }
            } else {
              if (job.lob === 'SE' || job.lob === 'SI') {
                this.states.planner.dataList = await User.getUsersByPrivilegeDetail('role', 'sealine', null, this.$store.getters.currentOfficeId)
              } else if (job.lob === 'AE' || job.lob === 'AI') {
                this.states.planner.dataList = await User.getUsersByPrivilegeDetail('role', 'airline', null, null)
              } else {
                // 原cargo的bug，补充铁出的设值， 铁出是新加的，入参和海出一致
                this.states.planner.dataList = await User.getUsersByPrivilegeDetail('role', 'railwayLine', null, this.$store.getters.currentOfficeId)
              }
            }
            this.states.planner.value = job.planner
            obj.newValue1 = job.plannerDepartment
          } else {
            this.states.planner.value = 0
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 11:
          this.currentState = 'date'
          this.states.date.visible = true
          if (job) {
            this.states.date.value = moment().format('YYYY-MM-DD')
            // 设置旧值
            if (job.lob === 'AE' || job.lob === 'SE' || job.lob === 'RE') {
              obj.oldValue = job.etd
            } else {
              obj.oldValue = job.eta
            }
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 12:
          if (this.openProjectConfig) {
            this.currentState = 'projectNo'
            if (job) {
              this.states.projectNo.value = job.poNo
            }
            this.customerId = job.customerId
          } else {
            this.currentState = 'init'
            if (job) {
              this.states.init.value = job.poNo
            }
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 13:
          this.currentState = 'customer'
          if (job) {
            this.states.customer.value = job.customerId
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 14:
          this.currentState = 'designationAgent'
          if (job) {
            this.states.designationAgent.value = job.destinationAgent
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 15:
          this.currentState = 'designationAgent'
          if (job) {
            if (job.lob === 'AI') {
              this.states.designationAgent.value = job.loadingAgentId
              obj.filedCode = 'LOADING_AGENT'
              obj.oldValue = job.loadingAgentId
            } else {
              this.states.designationAgent.value = job.destinationAgent
            }
          }
          obj.filedTable = 'OMS_JOB'
          //						obj.filedCode = 15;
          break
        case 16:
          this.currentState = 'init'
          if (job && job.lob === 'AE') {
            this.states.init.value = String(job.cWeight)
          } else {
            this.states.init.value = ''
          }
          obj.filedTable = 'OMS_AIR_EXPORT_JOB'
          break
        case 17:
          this.currentState = 'overseaOp'
          this.states.overseaOp.dataList = await User.getUsersByPrivilegeDetail('role', 'overseaOp', null, this.$store.getters.currentOfficeId)
          if (job) {
            this.states.overseaOp.value = job.overseaOp
            obj.newValue1 = job.overseaOpDepartment
          } else {
            this.states.overseaOp.value = 0
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 18:
          this.currentState = 'designationAgent'
          if (job) {
            this.states.designationAgent.value = job.designationAgent
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 20:
          this.currentState = 'jobType'
          if (job) {
            this.states.jobType.lob = job.lob
            this.states.jobType.value = job.customJobType
            this.states.jobType.value = job.customJobType
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 21:
          this.currentState = 'carrierAgent'
          if (job) {
            this.states.carrierAgent.value = job.carrierAgentId
          }
          switch (this.job.lob) {
            case 'SE':
              this.states.carrierAgent.methodParams.seaExport = true
              break
            case 'SI':
              this.states.carrierAgent.methodParams.seaImport = true
              break
            case 'AE':
              this.states.carrierAgent.methodParams.airExport = true
              break
            case 'AI':
              this.states.carrierAgent.methodParams.airImport = true
              break
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 22:
          this.currentState = 'customsBroker'
          if (job) {
            this.states.customsBroker.value = job.customsBroker
            obj.oldValue = job.customsBroker
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 23:
          this.currentState = 'trucking'
          if (job) {
            this.states.trucking.value = job.carryingCmp
            // console.log('job.carryingCmp', job.carryingCmp, job.trucking)
            obj.oldValue = job.carryingCmp || '0'
            obj.quantity = job.quantityActual
            obj.weight = job.weightActual
            obj.cubage = job.cubageActual
            if (job.trucking) { obj.oldTruckingInfoCount = job.trucking.length + '' } else { obj.oldTruckingInfoCount = '0' }
          }
          obj.filedTable = 'OMS_TRUCKING_INFO'
          break
        case 24:
          this.currentState = 'warehouse'
          if (job) {
            if (job.warehouseInfo && job.warehouseInfo.length > 0) {
              const warehouseId = job.warehouseInfo[0].warehouseCmp
              this.states.warehouse.value = warehouseId
              obj.oldValue = warehouseId
              obj.oldWarehouseInfoCount = job.warehouseInfo.length
            } else {
              this.states.warehouse.value = 0
              obj.oldValue = 0
              obj.oldWarehouseInfoCount = 0
            }
            obj.quantity = job.quantityActual
            obj.weight = job.weightActual
            obj.cubage = job.cubageActual
          }
          obj.filedTable = 'OMS_WAREHOUSE_INFO'
          break
        case 25:
          this.currentState = 'date'
          this.states.date.visible = true
          if (job) {
            this.states.date.value = job.eta || moment().format('YYYY-MM-DD')
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 26:
          this.currentState = 'date'
          this.states.date.visible = true
          if (job) {
            this.states.date.value = job.eta || moment().format('YYYY-MM-DD')
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 27:
          this.currentState = 'bookingterm'
          if (job) {
            if (job.lob === 'AE') {
              this.states.bookingterm.cacheKey = TYPE_NAMES.local_cache_BookingTerm
              this.states.bookingterm.value = job.bookingTerm
            }
          }
          break
        case 28:
          this.currentState = 'textarea'
          if (job) {
            this.states.textarea.value = job.userDefinedField1
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 29:
          this.currentState = 'textarea'
          if (job) {
            this.states.textarea.value = job.userDefinedField2
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 30:
          this.currentState = 'textarea'
          if (job) {
            this.states.textarea.value = job.userDefinedField3
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 31:
          this.currentState = 'textarea'
          if (job) {
            this.states.textarea.value = job.userDefinedField4
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 32:
          this.currentState = 'userDefinedRoleId1'
          if (this.states.userDefinedRoleId1.dataList.length > 0) {
            // 判断是否已经获取过值
            break
          }
          if (job) {
            if (job.userDefinedRoleOffice1 && job.userDefinedRoleOffice1 !== 0) {
              this.states.userDefinedRoleId1.dataList = await User.getUsersByPrivilegeDetail('role', 'userDefinedRole1', null, this.job.userDefinedRoleOffice1)
            } else {
              this.states.userDefinedRoleId1.dataList = await User.getUsersByPrivilegeDetail('role', 'userDefinedRole1', null, this.$store.getters.currentOfficeId)
            }

            this.states.userDefinedRoleId1.value = job.userDefinedRoleId1
            obj.newValue1 = job.userDefinedRoleDept1
            obj.newValue2 = job.userDefinedRoleOffice1
          } else {
            this.states.userDefinedRoleId1.dataList = await User.getUsersByPrivilegeDetail('role', 'userDefinedRole1', null, currentOffice.code === 'HQ' ? null : this.$store.getters.currentOfficeId)
            this.states.userDefinedRoleId1.value = 0
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 33:
          if (this.states.userDefinedRoleId2.dataList.length > 0) {
            // 判断是否已经获取过值
            break
          }
          this.currentState = 'userDefinedRoleId2'
          if (job) {
            if (job.userDefinedRoleOffice2 && job.userDefinedRoleOffice2 !== 0) {
              this.states.userDefinedRoleId2.dataList = await User.getUsersByPrivilegeDetail('role', 'userDefinedRole2', null, this.job.userDefinedRoleOffice2)
            } else {
              this.states.userDefinedRoleId2.dataList = await User.getUsersByPrivilegeDetail('role', 'userDefinedRole2', null, this.$store.getters.currentOfficeId)
            }

            this.states.userDefinedRoleId2.value = job.userDefinedRoleId2
            obj.newValue1 = job.userDefinedRoleDept2
            obj.newValue2 = job.userDefinedRoleOffice2
          } else {
            this.states.userDefinedRoleId2.dataList = await User.getUsersByPrivilegeDetail('role', 'userDefinedRole2', null, currentOffice.code === 'HQ' ? null : this.$store.getters.currentOfficeId)
            this.states.userDefinedRoleId2.value = 0
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 34:
        case 35:
          this.currentState = 'date'
          this.states.date.visible = true
          if (job) {
            this.states.value = job.etd || moment().format('YYYY-MM-DD')
            obj.oldValue = job.etd
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 36:
        case 37:
          this.currentState = 'date'
          this.states.date.visible = true
          if (job) {
            this.states.value = job.atd || moment().format('YYYY-MM-DD')
            obj.oldValue = job.atd
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 38:
        case 39:
          this.currentState = 'date'
          this.states.date.visible = true
          if (job) {
            this.states.value = job.ata || moment().format('YYYY-MM-DD')
            obj.oldValue = job.ata
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 40:
          this.currentState = 'salesOfGoods'
          if (this.states.salesOfGoods.dataList.length > 0) {
            // 判断是否已经获取过值
            break
          }
          if (job) {
            this.states.salesOfGoods.dataList = await User.getUsersByPrivilegeDetail('role', 'salesOfGoods', null, this.$store.getters.currentOfficeId)
            this.states.salesOfGoods.value = job.cargoSalesId
            obj.newValue1 = job.cargoSalesDepartment
            obj.newValue2 = job.cargoSalesOffice
          } else {
            this.states.salesOfGoods.dataList = await User.getUsersByPrivilegeDetail('role', 'salesOfGoods', null, currentOffice.code === 'HQ' ? null : this.$store.getters.currentOfficeId)
            this.states.salesOfGoods.value = this.states.salesOfGoods.value || 0
          }
          obj.filedTable = 'OMS_JOB'
          break
        case 41:
          this.currentState = 'loadingPort'
          if (job) {
            this.states.loadingPort.value = job.loadingPortCode
            if (job.lob === 'IE') {
              obj.quantity = job.containerLoadType
            }
          }
          break
        case 42:
          this.currentState = 'dischargingPort'
          if (job) {
            this.states.dischargingPort.value = job.dischargingPortCode
            obj.newValue1 = this.isSyncPOD
            if (!this.isSyncPOD) {
              obj.newValue2 = job.destinationPortCode
            }
            if (job.lob === 'IE') {
              obj.quantity = job.containerLoadType
            }
          }
          break
        case 43:
          this.currentState = 'loadingAirport'
          if (job) {
            this.states.loadingAirport.value = job.loadingPortCode
          }
          break
        case 44:
          this.currentState = 'dischargingAirport'
          if (job) {
            this.states.dischargingAirport.value = job.destinationPortCode
          }
          break
        case 45:
          this.currentState = 'dischargingAirportImport'
          if (job) {
            this.states.dischargingAirportImport.value = job.dischargingPortCode
          }
          break
        case 46:
          this.currentState = 'departureStation'
          if (job) {
            this.states.departureStation.value = job.departureStation
            obj.oldValue = job.departureStation
          }
          break
        case 47:
          this.currentState = 'destinationStation'
          if (job) {
            this.states.destinationStation.value = job.destinationStation
            obj.oldValue = job.destinationStation
          }
          break
        case 48:
          this.currentState = 'goodsCategories'
          if (job) {
            this.states.goodsCategories.value = job.cargoCode
            obj.oldValue = job.cargoCode
          }
          break
        case 49:
          this.currentState = 'incoTerm'
          if (job) {
            this.states.incoTerm.value = job.incoTerm
            obj.oldValue = job.incoTerm
          }
          break
        case 55:
          this.currentState = 'customerRemarks'
          if (job) {
            queryCustomerRemarksHistory().then(res => {
              this.states.customerRemarks.dataList = res.data
            })
            if (obj['lob'] === 'SI') {
              obj.filedTable = 'OMS_SEA_IMPORT_JOB'
            }
            obj.filedCode = 'CUSTOMER_REMARKS'
            this.states.customerRemarks.value = job.customerRemarks
            obj.oldValue = job.customerRemarks
          }
          break
        case 56:
          this.currentState = 'paymentTermMBL'
          obj.filedCode = 'PAYMENT_TERM_MBL'
          obj.filedTable = 'OMS_JOB'

          if (job) {
            this.states.paymentTermMBL.value = job.paymentTermMBL
            obj.oldValue = job.paymentTermMBL
          }
          break
        case 57:
          this.currentState = 'paymentTermHBL'
          obj.filedCode = 'PAYMENT_TERM_HBL'
          obj.filedTable = 'OMS_JOB'

          if (job) {
            this.states.paymentTermHBL.value = job.paymentTermHBL
            obj.oldValue = job.paymentTermHBL
          }
          break
        case 58:
          this.currentState = 'forwardingAgent'
          if (job) {
            this.states.forwardingAgent.value = job.forwardingAgent
          }
          obj.filedTable = 'OMS_RAILWAY_EXPORT_JOB'
          break
      }
    },
    async onUserChange(user) {
      if (user) {
        this.states[this.currentState].value = Number(user.userId)
        switch (this.currentState) {
          case this.states.sales.state:
            await this.salesChangeHandler(user)
            break
          case this.states.dc.state:
            await this.dcChangeHandler(user)
            break
          case this.states.overseaOp.state:
            await this.overseaOpChangeHandler(user)
            break
          case this.states.op.state:
            await this.opChangeHandler(user)
            break
          case this.states.csr.state:
            await this.csrChangeHandler(user)
            break
          case this.states.planner.state:
            await this.plannerChangeHandler(user)
            break
          case this.states.userDefinedRoleId1.state:
            await this.userDefinedRoleId1ChangeHandler(user)
            break
          case this.states.userDefinedRoleId2.state:
            await this.userDefinedRoleId2ChangeHandler(user)
            break
          case this.states.salesOfGoods.state:
            await this.salesOfGoodsChangeHandler(user)
            break
        }
      }
    },
    async plannerChangeHandler(user) {
      if (user) {
        const department = await this.getUserModel4Cache(user.userId).getDefaultDepartment('role', 'sales')
        this.getPlannerResult(department)
      } else {
        this.resultData.newValue1 = 0
        this.states.planner.value = ''
      }
    },
    getPlannerResult(department) {
      this.resultData.newValue1 = department ? department.departmentId : 0
    },
    async csrChangeHandler(user) {
      const obj = this.resultData
      if (user) {
        await this.getUserDepartment(user, 'role', 'csr')
      } else {
        obj.newValue1 = 0
        obj.newValue2 = 0
        this.states.csr.value = ''
      }
    },
    async overseaOpChangeHandler(user) {
      if (user) {
        const department = await this.getUserModel4Cache(user.userId).getDefaultDepartment('role', 'overseaOp')
        this.getDefaultOverseaOpResult(department)
      } else {
        this.resultData.newValue1 = 0
        this.states.overseaOp.value = ''
      }
    },
    getDefaultOverseaOpResult(department) {
      this.resultData.newValue1 = department ? department.departmentId : 0
    },
    async dcChangeHandler(user) {
      if (user) {
        const department = await this.getUserModel4Cache(user.userId).getDefaultDepartment('role', 'doc')
        await this.getDefaultDocResult(department)
      } else {
        this.resultData.newValue1 = 0
        this.states.dc.value = ''
      }
    },
    async getDefaultDocResult(department) {
      const obj = this.resultData
      if (department) {
        obj.newValue1 = department.departmentId
        obj.newValue2 = (await Office.getOfficeByUuid(department.officeUuid)).officeId
      } else {
        obj.newValue1 = 0
        obj.newValue2 = 0
      }
    },
    async getDefaultOpResult(dep) {
      const obj = this.resultData
      if (dep) {
        obj.newValue1 = dep.departmentId
        let officeId = dep.office.officeId
        if (!officeId && dep.officeUuid) {
          officeId = (await Office.getOfficeByUuid(dep.officeUuid)).officeId
        }
        obj.newValue2 = officeId
      } else {
        obj.newValue1 = 0
        obj.newValue2 = 0
      }
    },
    async opChangeHandler(user) {
      const obj = this.resultData
      if (user) {
        // 判断用户是否配置默认部门公司
        if (user && user.defaultDepId > 0) {
          const departments = await getFilterCacheList(cacheKeys.basic_data_Department_All, (item) => {
            return item.departmentId === user.defaultDepId
          }) || []
          await this.getDefaultOpResult(departments[0])
        } else {
          const userId = user.userId
          // 获取该用户所有有操作权限的部门
          const officeList = this.userDepartmentOfficesCacheMap.has(userId) ? this.userDepartmentOfficesCacheMap.get(userId) : await User.getUserDepartmentOffices('role', 'op', user.userId)
          this.userDepartmentOfficesCacheMap.set(userId, officeList)
          await this.getUserOpOfficesHandler(officeList, user)
        }
      } else {
        obj.newValue1 = 0
        obj.newValue2 = 0
        this.states.op.value = ''
      }
    },
    async getUserOpOfficesHandler(officeList, user) {
      let d = false
      const result = officeList
      const obj = this.resultData
      // 当前用户部门存在多个时，根据当前分公司过滤
      if (result != null && result.length > 1) {
        for (const item of result) {
          if (parseInt(item.officeId) === this.$store.getters.currentOfficeId) {
            obj.newValue1 = parseInt(item.departmentId)
            obj.newValue2 = parseInt(item.officeId)
            d = true
            break
          }
        }
      }
      // 当前用户仅有一个部门或以上过滤未存在当前分公司部门随机获取默认部门
      if (!d) {
        const department = await this.getUserModel4Cache(user.userId).getDefaultDepartment('role', 'op', this.job.opOffice)
        await this.getDefaultOpResult(department)
      }
    },
    async salesChangeHandler(user) {
      const obj = this.resultData
      // 用户设置了默认公司和部门就用默认的
      if (user) {
        if (user.defaultDepId !== 0) {
          obj.newValue1 = user.defaultDepId
          obj.newValue2 = user.defaultOfficeId
        } else {
          const userId = user.userId
          const officeList = this.userDepartmentOfficesCacheMap.has(userId) ? this.userDepartmentOfficesCacheMap.get(userId) : await User.getUserDepartmentOffices('role', 'sales', user.userId)
          this.userDepartmentOfficesCacheMap.set(userId, officeList)
          await this.getUserDepartmentOfficesHandler(officeList, user)
        }
      } else {
        obj.newValue1 = 0
        obj.newValue2 = 0
        this.states.sales.value = ''
      }
    },
    async getUserDepartmentOfficesHandler(officeList, user) {
      const obj = this.resultData
      obj.newValue2 = this.job.salesOffice
      if (this.salesOfficeCheck) {
        obj.newValue2 = this.$store.getters.currentOfficeId
      }
      if (officeList && officeList.length > 1) {
        for (const item of officeList) {
          if (this.branchOfficeCheck || (!this.branchOfficeCheck && parseInt(item.officeId) === obj.newValue2)) {
            obj.newValue1 = parseInt(item.departmentId)
            break
          }
        }
      } else {
        const department = await this.getUserModel4Cache(user.userId).getDefaultDepartment('role', 'sales')
        await this.getDefaultSalesOpResult(department)
      }
    },
    async getDefaultSalesOpResult(department) {
      this.resultData.newValue1 = department ? department.departmentId : 0
    },
    getUserModel4Cache(userId) {
      if (this.userDepartmentCacheMap.has(userId)) {
        return this.userDepartmentCacheMap.get(userId)
      } else {
        const user = new User({ userId })
        this.userDepartmentCacheMap.set(userId, user)
        return user
      }
    },
    async preProcessBeforeConfirm() {
      const obj = this.resultData
      const job = this.job
      const select = Number(this.adjustmentItem.value)
      if (select === 0) {
        // this.$message.warning('请选择需要修改的内容.')
        // return
        await Assert.isTrue(false, this.$t('FinanceManage.selectAdjustmentItem'), 'warning')
      } else if (select === 1) {
        obj.newValue = this.states.csr.value
      } else if (select === 2) {
        obj.newValue = this.states.op.value
      } else if (select === 3) {
        obj.newValue = this.states.dc.value
      } else if (select === 4 || select === 27) {
        if (obj['lob'] === 'SE') {
          obj.filedTable = 'OMS_SEA_EXPORT_JOB'
        }
        if (obj['lob'] === 'AE') {
          obj.filedTable = 'OMS_AIR_EXPORT_JOB'
        }
        if (obj['lob'] === 'SI') {
          obj.filedTable = 'OMS_SEA_IMPORT_JOB'
        }
        obj.newValue = this.states.bookingterm.value
      } else if (select === 5) {
        obj.newValue = this.states.bookingAgent.value === '' ? '0' : this.states.bookingAgent.value
      } else if (select === 6) {
        obj.newValue = this.states.carrier.value === '' ? '0' : this.states.carrier.value
      } else if (select === 7) {
        obj.newValue = this.states.cargoSource.value
        // todo
        if (this.states.cargoSource.value === 'NC') {
          obj.newValue2 = this.resultData.newValue2
        } else {
          obj.newValue2 = 0
        }
      } else if (select === 8) {
        obj.newValue = this.states.sales.value
      } else if (select === 9 || select === 16) {
        obj.newValue = this.states.init.value
      } else if (select === 10) {
        obj.newValue = this.states.planner.value
      } else if (select === 12) { // 项目编号
        if (this.openProjectConfig) {
          obj.newValue = this.states.projectNo.value
        } else {
          obj.newValue = this.states.init.value
        }
      } else if (select === 11 || select === 25 || select === 26 || select === 34 || select === 35 || select === 36 || select === 37 || select === 38 || select === 39) {
        obj.newValue = this.states.date.value
      } else if (select === 13) {
        obj.newValue = this.states.customer.value || 0
      } else if (select === 14 || select === 15) {
        obj.newValue = this.states.designationAgent.value === '' ? '0' : this.states.designationAgent.value
      } else if (select === 17) {
        obj.newValue = this.states.overseaOp.value
      } else if (select === 18) {
        obj.newValue = this.states.designationAgent.value === '' ? '0' : this.states.designationAgent.value
      } else if (select === 20) {
        obj.newValue = this.states.jobType.value
      } else if (select === 21) {
        obj.newValue = this.states.carrierAgent.value === '' ? '0' : this.states.carrierAgent.value
      } else if (select === 22) {
        obj.filedTable = 'OMS_JOB'
        obj.newValue = this.states.customsBroker.value === '' ? '0' : this.states.customsBroker.value
        let isCustomsCheck = false
        if (obj['lob'] === 'SE') {
          obj.lob = ' OMS_SEA_EXPORT_JOB'
          isCustomsCheck = job.customs
        }
        if (obj['lob'] === 'AE') {
          obj.lob = 'OMS_AIR_EXPORT_JOB'
        }
        if (obj['lob'] === 'SI') {
          obj.lob = 'OMS_SEA_IMPORT_JOB'
          isCustomsCheck = job.customs
        }
        if (obj['lob'] === 'AI') {
          obj.lob = 'OMS_AIR_IMPORT_JOB'
          isCustomsCheck = job.customs
        }

        if ((job.masterFlag === true && job.lob.indexOf('I') > -1) || job.lob === 'AE') {
          obj.noCheck = '1'
        } else {
          obj.oldValue1 = isCustomsCheck ? 1 : 0
          if (obj.newValue > 0) {
            obj.newValue1 = 1
          } else {
            obj.newValue1 = 0
          }
        }
      } else if (select === 23) {
        obj.filedTable = 'OMS_TRUCKING_INFO'
        obj.newValue = this.states.trucking.value
        obj.noCheck = '1'
      } else if (select === 24) {
        obj.filedTable = 'OMS_WAREHOUSE_INFO'
        obj.newValue = this.states.warehouse.value === '' ? '0' : this.states.warehouse.value

        if ((job.masterFlag === true && job.lob.indexOf('I') > -1) || job.lob === 'AE') {
          obj.noCheck = '1'
        } else {
          obj.oldValue1 = job.warehousing ? 1 : 0
          if (obj.newValue > 0) { obj.newValue1 = 1 } else { obj.newValue1 = 0 }
        }
      } else if (select === 28 || select === 29 || select === 30 || select === 31) {
        obj.newValue = this.states.textarea.value
      } else if (select === 32) {
        obj.newValue = this.states.userDefinedRoleId1.value
      } else if (select === 33) {
        obj.newValue = this.states.userDefinedRoleId2.value
      } else if (select === 40) {
        obj.newValue = this.states.salesOfGoods.value
      } else if (select === 41) {
        obj.newValue = this.states.loadingPort.value
      } else if (select === 42) {
        obj.newValue = this.states.dischargingPort.value
      } else if (select === 43) {
        obj.newValue = this.states.loadingAirport.value
      } else if (select === 44) {
        obj.newValue = this.states.dischargingAirport.value
      } else if (select === 45) {
        obj.newValue = this.states.dischargingAirportImport.value
      } else if (select === 46) {
        obj.newValue = this.states.departureStation.value
      } else if (select === 47) {
        obj.newValue = this.states.destinationStation.value
      } else if (select === 48) {
        obj.newValue = this.states.goodsCategories.value
        const cargoInformation = getObjectByCache(cacheKeys.basic_data_CargoInformation, 'code', obj.newValue)
        if (cargoInformation) {
          obj.newValue1 = cargoInformation.englishName
        }
      } else if (select === 49) {
        obj.newValue = this.states.incoTerm.value
      } else if (select === 55) {
        obj.newValue = this.states.customerRemarks.value
      } else if (select === 56) {
        obj.newValue = this.states.paymentTermMBL.value
      } else if (select === 57) {
        obj.newValue = this.states.paymentTermHBL.value
      } else if (select === 58) {
        obj.newValue = this.states.forwardingAgent.value === '' ? '0' : this.states.forwardingAgent.value
      }
      obj.type = 1
    },
    async confirm() {
      await this.preProcessBeforeConfirm()

      const obj = this.resultData
      const select = Number(this.adjustmentItem.value)
      if ((select === 4 || select === 7) && obj.newValue === '') {
        this.$message.info(this.$t('Clearing.ThisFieldCannotBeEmpty'))
        return
      }
      this.$logger.log('resultData', this.resultData, JSON.stringify(this.resultData))
      if (!this.check()) return

      const jobKeys = [this.job.uuid]
      if (this.job.masterFlag && (this.resultData.filedCode === 'BUSINESS_DATE' || this.resultData.filedCode === 'ETD' || this.resultData.filedCode === 'ETA' ||
        this.resultData.filedCode === 'ATD' || this.resultData.filedCode === 'ATA' || this.resultData.filedCode === 'PORT_OF_LOADING' ||
        this.resultData.filedCode === 'PORT_OF_DISCHARGE' || this.resultData.filedCode === 'AIRPORT_OF_LOADING' || this.resultData.filedCode === 'AIRPORT_OF_DISCHARGE' ||
        this.resultData.filedCode === 'AIRPORT_IMPORT_OF_DISCHARGE' || this.resultData.filedCode === 'DEPARTURE_STATION' || this.resultData.filedCode === 'DESTINATION_STATION' ||
        this.resultData.filedCode === 'BOOKING_AGENT' || this.resultData.filedCode === 'FORWARDING_AGENT' || this.resultData.filedCode === 'CARRIER_ID')) {
        if (!this.job.lclSlaves) {
          await new Job(this.job).getLclSlaves()
        }
        for (const lclSlave of this.job.lclSlaves) {
          jobKeys.push(lclSlave.uuid)
        }
      }
      await Job.updateJob(jobKeys, this.resultData)
      this.$message.success(this.$t('FinanceManage.businessInfoAdjustedSuccess'))
      // 增加埋点
      // LogStores.sendFunctionClickLogStoresByLabel("结算-财务审核—业务调整—"+map["filedCode"]);
      this.$emit('confirm')
      this.$emit('update:visible', false)
    },
    // 验证必填项
    check() {
      const obj = this.resultData
      if (obj && this.currentState === 'op') {
        if (!obj.newValue || obj.newValue <= 0) {
          this.$message.warning(this.$t('Clearing.OperationCannotBeEmpty'))
          return false
        }
        if (!obj.newValue1 || obj.newValue1 <= 0) {
          this.$message.warning(this.$t('Clearing.OperationDepartmentCannotBeEmpty'))
          return false
        }
        if (!obj.newValue2 || obj.newValue2 <= 0) {
          this.$message.warning(this.$t('Clearing.OperationBranchCannotBeEmpty'))
          return false
        }
      }
      if (obj.filedCode === 'SALES_ID' && !obj.newValue) {
        this.$message.warning(this.$t('FinanceManage.ExportBusinessItemCannotEmpty'))
        return false
      }
      if ((obj.filedCode === 'ETD' || obj.filedCode === 'BUSINESS_DATE' || obj.filedCode === 'PORT_OF_LOADING' || obj.filedCode === 'PORT_OF_DISCHARGE' ||
          obj.filedCode === 'AIRPORT_OF_LOADING' || obj.filedCode === 'AIRPORT_OF_DISCHARGE' || obj.filedCode === 'AIRPORT_IMPORT_OF_DISCHARGE' ||
          obj.filedCode === 'DEPARTURE_STATION' || obj.filedCode === 'DESTINATION_STATION') &&
        !obj.newValue && (obj.lob === 'SE' || obj.lob === 'AE' || obj.lob === 'RE')) {
        this.$message.warning(this.$t('FinanceManage.ExportBusinessItemCannotEmpty'))
        return false
      }
      if ((obj.filedCode === 'ETA' || obj.filedCode === 'BUSINESS_DATE' || obj.filedCode === 'PORT_OF_LOADING' || obj.filedCode === 'PORT_OF_DISCHARGE' ||
        obj.filedCode === 'AIRPORT_OF_LOADING' || obj.filedCode === 'AIRPORT_OF_DISCHARGE' || obj.filedCode === 'AIRPORT_IMPORT_OF_DISCHARGE' ||
        obj.filedCode === 'DEPARTURE_STATION' || obj.filedCode === 'DESTINATION_STATION') &&
        !obj.newValue && (obj.lob === 'SI' || obj.lob === 'AI' || obj.lob === 'RI')) {
        this.$message.warning(this.$t('FinanceManage.ImportBusinessItemCannotEmpty'))
        return false
      }
      if ((obj.filedCode === 'PORT_OF_LOADING' || obj.filedCode === 'PORT_OF_DISCHARGE') && !obj.newValue && obj.lob === 'IE' && obj.quantity === 'IC') {
        this.$message.warning(this.$t('FinanceManage.LandTransportationBusinessItemCannotEmpty'))
        return false
      }
      return true
    },
    cancel() {
      this.$emit('update:visible', false)
    },
    // 自定义岗位1
    async userDefinedRoleId1ChangeHandler(user) {
      if (user) {
        const department = await this.getUserModel4Cache(user.userId).getDefaultDepartment('role', 'userDefinedRole1')
        await this.getDefaultUserDefinedRoleId1Result(department)
      } else {
        this.resultData.newValue1 = 0
        this.states.userDefinedRoleId1.value = ''
      }
    },
    async getDefaultUserDefinedRoleId1Result(department) {
      const obj = this.resultData
      if (department) {
        obj.newValue1 = department.departmentId
        obj.newValue2 = (await Office.getOfficeByUuid(department.officeUuid)).officeId
      } else {
        obj.newValue1 = 0
        obj.newValue2 = 0
      }
    },
    // 自定义岗位2
    async userDefinedRoleId2ChangeHandler(user) {
      if (user) {
        const department = await this.getUserModel4Cache(user.userId).getDefaultDepartment('role', 'userDefinedRole2')
        await this.getDefaultUserDefinedRoleId2Result(department)
      } else {
        this.resultData.newValue1 = 0
        this.states.userDefinedRoleId2.value = ''
      }
    },
    async getDefaultUserDefinedRoleId2Result(department) {
      const obj = this.resultData
      if (department) {
        obj.newValue1 = department.departmentId
        obj.newValue2 = (await Office.getOfficeByUuid(department.officeUuid)).officeId
      } else {
        obj.newValue1 = 0
        obj.newValue2 = 0
      }
    },
    async salesOfGoodsChangeHandler(user) {
      const obj = this.resultData
      if (user) {
        const department = await this.getUserModel4Cache(user.userId).getDefaultDepartment('role', 'salesOfGoods')
        await this.getSalesOfGoodsDefaultResult(department)
      } else {
        obj.newValue1 = 0
        obj.newValue2 = 0
        this.states.salesOfGoods.value = ''
      }
    },
    async getSalesOfGoodsDefaultResult(department) {
      const obj = this.resultData
      if (department) {
        obj.newValue1 = department.departmentId
        if (department.officeUuid) {
          obj.newValue2 = (await Office.getOfficeByUuid(department.officeUuid)).officeId
        } else {
          obj.newValue2 = 0
        }
      } else {
        obj.newValue1 = 0
        obj.newValue2 = 0
      }
    },
    changeProject(item) { // 修改项目编号
      const obj = this.resultData
      if (item) {
        this.states.projectNo.value = item.value
        obj.newValue1 = item.projectName
        obj.newValue2 = this.openProjectConfig
      } else {
        this.states.projectNo.value = ''
        obj.newValue1 = ''
        obj.newValue2 = this.openProjectConfig
      }
    },
    selectCustomerRemarksBlur(event) {
      this.states.customerRemarks.value = event.target.value
    },
    async getUserDepartment(user, category = '', shape = '') {
      const obj = this.resultData
      let newValue1 = 0
      let newValue2 = 0
      if (user && user.userId > 0) {
        if (user) {
          const offices = await User.getUserDepartmentOffices(category, shape, user.userId)
          if (offices && offices.length > 1) {
            for (const item of offices) {
              if (item.officeId === this.$store.getters.currentOfficeId) {
                newValue1 = item.departmentId
                const office = await Office.getOfficeById(item.officeId)
                newValue2 = office ? office.officeId : 0
                break
              }
            }
          } else {
            const dep = await new User(user).getDefaultDepartment(category, shape)
            if (dep) {
              newValue1 = dep.departmentId
              const office = await Office.getOfficeByUuid(dep.officeUuid)
              newValue2 = office ? office.officeId : 0
            }
          }
        }
      }
      obj.newValue1 = newValue1 || 0
      obj.newValue2 = newValue2 || 0
    }
  }
}
</script>

<style lang="scss">
</style>
